import MaskedInput from 'react-text-mask'
import React from 'react'

import { masks } from '../../../utils'

const PhoneOrMobileInput = ({ inputRef, ...rest }) => (
  <MaskedInput
    ref={ref => {
      inputRef(ref ? ref.inputElement : null)
    }}
    mask={masks.phoneOrMobile}
    showMask
    guide={false}
    {...rest}
  />
)

export default PhoneOrMobileInput
